<template>
  <el-container class="layout">
    <el-aside width="230px" class="aside">
      <div class="logo">智慧小广<span class="version-tag">{{ appVersion.version }}</span></div>
      <el-menu
        :default-active="$route.path"
        router
        background-color="#ffffff"
        text-color="#5f6f86"
        active-text-color="#2f6f9f"
      >
        <el-menu-item index="/dashboard"><i class="el-icon-s-home"></i><span>工作台</span></el-menu-item>
        <el-menu-item index="/resources"><i class="el-icon-office-building"></i><span>空置资源管理</span></el-menu-item>
        <el-menu-item index="/companies"><i class="el-icon-s-shop"></i><span>重点企业管理</span></el-menu-item>
        <el-menu-item index="/feedback"><i class="el-icon-chat-dot-round"></i><span>反馈管理</span></el-menu-item>
        <el-menu-item index="/special-applications"><i class="el-icon-document"></i><span>专项申请管理</span></el-menu-item>
        <el-menu-item v-if="isOps" index="/users"><i class="el-icon-user-solid"></i><span>用户管理</span></el-menu-item>
        <el-menu-item index="/password"><i class="el-icon-lock"></i><span>修改密码</span></el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="header">
        <div>{{ $route.meta.title || '后台管理' }}</div>
        <div class="user-area">
          <span>{{ user.nickname || user.username }}</span>
          <el-tag v-if="user.userType === 'ops'" size="mini" type="warning">运维</el-tag>
          <el-button size="mini" plain @click="logout">退出</el-button>
        </div>
      </el-header>
      <el-main class="main"><router-view /></el-main>
    </el-container>
  </el-container>
</template>

<script>
import { APP_VERSION } from '../version'
export default {
  data() {
    return {
      user: JSON.parse(localStorage.getItem('adminUser') || '{}'),
      appVersion: APP_VERSION
    }
  },
  computed: {
    isOps() {
      return this.user.userType === 'ops'
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('adminToken')
      localStorage.removeItem('adminUser')
      this.$router.replace('/login')
    }
  }
}
</script>

<style scoped>
.layout {
  min-height: 100vh;
}

.aside {
  background: #fff;
  box-shadow: 8px 0 24px rgba(47, 111, 159, 0.06);
}

.logo {
  height: 70px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 28px;
  color: #2f6f9f;
  font-size: 24px;
  font-weight: 900;
}

.version-tag {
  padding: 2px 8px;
  border-radius: 999px;
  background: #eef6ff;
  color: #7b91a8;
  font-size: 12px;
  font-weight: 700;
}

.header {
  height: 70px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(47, 111, 159, 0.05);
  font-weight: 800;
}

.main {
  padding: 26px;
}

.user-area {
  display: flex;
  gap: 14px;
  align-items: center;
  color: #6f8198;
  font-weight: 500;
}
</style>
